
import { validationMixin } from 'vuelidate'
import { email, required } from 'vuelidate/lib/validators'

import loginMixin from '~/mixins/auth/loginMixin'

import logo from '~/components/logo'

export default {
  components: {
    logo
  },

  mixins: [
    loginMixin,
    validationMixin
  ],

  validations: {
    form: {
      email: { email, required }
    }
  },

  data () {
    return {
      loading: false,
      showNotice: false,

      form: {
        email: null
      }
    }
  },

  head () {
    return {
      title: this.$t('password_recover.title'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('password_recover.desc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: this.$t('password_recover.desc')
        },
        { hid: 'og:title', name: 'og:title', content: this.$t('password_recover.title') },
        { hid: 'og:url', name: 'og:url', content: this.$config.baseUrl + this.localePath({ name: 'forgot' }) }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: this.breadldjson
        }
      ]
    }
  },

  created () {
    if (!!this.$auth.loggedIn) {
      this.$router.replace(this.localePath({ name: 'dashboard' }))
    }
  },

  methods: {
    validateState (name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },

    async onEmailEntered (e) {
      if (!!this.loading) {
        return
      }
      e.preventDefault()
      this.loading = true

      let token = false
      try {
        await this.$recaptcha.init()
        token = await this.$recaptcha.execute('resetPassword')
        await this.$recaptcha.destroy()
      } catch (e) {
        console.log('reCaptcha Error:', e)
      }

      if (!!token) {
        const fields = Object.assign({}, this.form)
        fields.rct = token
        const res = await this.apiLoginResetToken(fields)
        if (!res?.success) {
          this.$bvToast.toast(res.details ? res.details : (!!res.message ? res.message : res.exception), {
            title: this.$t('toast.header.error'),
            variant: 'danger',
            solid: true
          })
        } else {
          if (!!this.$gtag) {
            this.$gtag('event', 'password-reset')
          }

          this.showNotice = true
        }
      }

      this.loading = false
    }
  }
}
